import { styled } from "@mui/material";

export const Section = styled('main')(({ theme }) => (props) => ({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '80vh',
    gap: '12px',
    padding: '32px 48px',
    [theme.breakpoints.down('md')]: {
        padding: '24px  24px'
    },
    [theme.breakpoints.down('sm')]: {
        padding: '12px  12px ',
    },
    [theme.breakpoints.down('xs')]: {
        padding: '12px 6px',
    },
}))
export const Content = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    flex: '1'
}))